
export class HeaderButton {
	public text: string;
	public class?: string;
	public callback?: Function;
	public children?: Array<HeaderButton>;

	constructor(o?: any) {
		Object.assign(this, o);
	}
}